import { useTheme } from '@mui/material';
import clsx from 'clsx';
import isNil from 'lodash/isNil';

import { XAxisTickProps } from './types';
import { getThemeColor } from '../../../../utils/theme';

import { tokens } from '../../../../theme/generated/tokens';

export const XAxisTick = <V,>(props: XAxisTickProps<V>) => {
  const theme = useTheme();
  const {
    payload,
    index = 0,
    tickFormatter,
    className,
    x = 0,
    y: _y = 0,
    tickConfig,
    ...rest
  } = props;

  const label = tickFormatter?.(payload?.value, index) || payload?.value;
  if (isNil(label)) {
    return null;
  }

  const { width, height } = rest;
  const foWidth = Number(width ?? 0);
  const foHeight = Number(height ?? 0);

  const paddingX = tickConfig?.paddingX ?? 0;
  const paddingY = tickConfig?.paddingY ?? 0;
  const fontSize = tickConfig?.fontSize ?? 10;
  const backgroundColor = tickConfig?.backgroundColor
    ? getThemeColor(theme, tickConfig.backgroundColor)
    : 'transparent';
  const color = tickConfig?.color
    ? getThemeColor(theme, tickConfig.color)
    : 'currentColor';

  // Tick is centered on the 0 axis line, this adjusts it to be just below it
  const y = Number(_y) + fontSize / 2;

  return (
    <g transform={`translate(${x},${y})`}>
      <foreignObject
        x={-foWidth / 2}
        y={-fontSize}
        width={foWidth}
        height={foHeight}
        style={{ pointerEvents: 'none' }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <span
            className={clsx('x-axis-tick', className)}
            data-testid={`x-axis-tick-${index}`}
            style={{
              fontSize,
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 400,
              color,
              backgroundColor,
              borderRadius: tokens.theme.radius.sm,
              padding: `${paddingY}px ${paddingX}px`,
              lineHeight: 1,
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </span>
        </div>
      </foreignObject>
    </g>
  );
};
